<template>
    <ul :class="{
            '_e-FormErreur--visible' : errors.$dirty && errors.$error
        }"
        class="_e-FormErreur">
        <li :key='index' class='_e-FormErreur__item' v-for="(error,index) in listError">{{getMessage(error.type)}}</li>
    </ul>
</template>
<script>

  export default {
    name: 'FormErreur',
    props: {
      'errors': {
        type: Object, default: () => {
          return {
            $dirty: false,
            $error: false,
            $params: [],
            $touch: () => {},
          };
        },
      },
    },
    methods: {
      getMessage(type) {
        switch (type) {
          case 'numeric' :
            return 'La valeur saisie doit contenir uniquement des chiffres';
          case 'email' :
            return 'La valeur saisie doit être un email valide';
          case 'alpha' :
            return 'La valeur saisie doit contenir uniquement des lettres';
          case 'texte' :
            return 'La valeur saisie doit contenir uniquement des lettres';
          case 'alphaNum' :
            return 'La valeur saisie doit contenir que des lettres ou des chiffres';
        }
      },
    },
    computed: {
      listError() {
        let validationChecked = [];
        for (let validate in this.errors.$params) {
          if (!this.errors[validate]) {
            validationChecked.push({'type': validate, 'error': this.errors[validate]});
          }
        }
        return validationChecked;
      },
    },
  };
</script>
<style scoped>
    ._e-FormErreur {
        position: relative;
        transform: translateY(50px);
        opacity: 0;
        transition: 300ms;
        margin: 0;
        padding: 0;

    }

    ._e-FormErreur--visible {
        transform: translateY(0);
        opacity: 1;
    }

    ._e-FormErreur__item {
        display: block;
        margin: 0;
        margin-left: 3rem;
        margin-top: 10px;
        background: rgba(255, 0, 0, 0.8);
        color: white;
        padding: 3px 5px;
        border-left: 1px solid rgba(255, 0, 0, 0.8);
        border-radius: 4px;
    }
</style>